/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_No_Issues_ExportInputs */



/**
* | output |
* | --- |
* | "No issues to export" |
*
* @param {Manual_Qc_No_Issues_ExportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_no_issues_export = /** @type {((inputs?: Manual_Qc_No_Issues_ExportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_No_Issues_ExportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun incident a exporter")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Probleme beim Export")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun problema da esportare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проблем с экспортом нет.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay problemas para exportar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出无问题")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポートする問題はありません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निर्यात में कोई समस्या नहीं है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportar sem problemas.")
	return /** @type {LocalizedString} */ ("No issues to export")
});